import {definePreset} from '@primeng/themes';
import Nora from '@primeng/themes/nora';

export const PrimePreset = definePreset(Nora, {
  semantic: {
    focusRing: {
      color: 'var(--focus-ring-color)',
      offset: '0',
    },
    formField: {
      focusRing: {
        width: '0',
      },
      borderRadius: 'var(--input-border-radius)',
    },
    overlay: {
      select: {
        shadow: 'none',
      },
      popover: {
        shadow: 'none',
      },
    },
    colorScheme: {
      light: {
        formField: {
          borderColor: 'var(--input-border-color)',
          hover: {
            borderColor: 'var(--input-hover-border)',
          },
          focus: {
            borderColor: 'var(--input-hover-border)',
          },
        },
        overlay: {
          select: {
            borderColor: 'var(--input-border-color)',
          },
          popover: {
            borderColor: 'var(--input-border-color)',
          },
        },
      },
    },
    dark: {
      formField: {
        borderColor: 'var(--input-border-color)',
        hover: {
          borderColor: 'var(--input-hover-border)',
        },
        focus: {
          borderColor: 'var(--input-hover-border)',
        },
      },
      overlay: {
        select: {
          borderColor: 'var(--input-border-color)',
        },
        popover: {
          borderColor: 'var(--input-border-color)',
        },
      },
    },
  },
});
